import PropTypes from 'prop-types';
import React from 'react';
import { Dimmer } from 'semantic-ui-react';
import NewWindow from '../../newWindow';


const windowFeatures = {
  resizable: 1,
  scrollbars: 1,
  status: 1,
  location: 'no',
  left: 200,
  right: 200,
  width: 940,
  height: 840,
};

class PopupPaymentWindow extends React.Component {
  static propTypes = {
    url: PropTypes.string.isRequired,
    paymentFields: PropTypes.object.isRequired,
    onPaymentComplete: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.windowMounted = (ref) => {
      if (ref) {
        if (this.windowRef) {
          this._removeEventListeners();
        }
        this.windowRef = ref;
        this._addEventListeners();
      }
    };
  }

  componentWillUnmount() {
    this._removeEventListeners();
    if (this.windowRef && this.windowRef.current && this.windowRef.current.window) {
      this.windowRef.current.window.close();
    }
  }

  // eslint-disable-next-line
  componentDidCatch(error, info) {
    // eslint-disable-next-line
    console.log(error);
  }

  handleWindowMounted = () => {
    if (this.formRef.current) {
      this.formRef.current.submit();
    }
  }

  handleFocus = () => {
    if (this.windowRef && this.windowRef.window && !this.windowRef.window.closed) {
      this.windowRef.window.focus();
    }
  };

  handleWindowClose = () => {
    if (!this.paymentReceived) {
      this.props.onPaymentComplete();
    }
  };

  handleWindowBlock = () => {
    // eslint-disable-next-line
    console.log('Popup Blocked');
    this.props.onPaymentComplete({
      error: true,
      message: 'Please disable popup blocker to display the payment page.',
    });
  }

  onPostMessage = (event) => {
    if (event.origin !== window.location.origin) {
      return;
    }
    if (event.data && event.data.action === 'paymentCallbackReceived') {
      this.paymentReceived = true;
      this.props.onPaymentComplete(event.data.parsedQuery);
    }
  }

  _addEventListeners() {
    window.addEventListener('message', this.onPostMessage, false);
  }

  _removeEventListeners() {
    window.removeEventListener('message', this.onPostMessage);
  }

  render() {
    const { url, paymentFields } = this.props;
    return (
      <React.Fragment>
        <form ref={this.formRef} action={url} target="paymentWindow" method="post">
          {
            Object.entries(paymentFields).map(paymentField => (
              <input key={paymentField[0]} type="hidden" name={paymentField[0]} value={paymentField[1]} />
            ))
          }
        </form>
        <Dimmer
          active
          page
          onClickOutside={this.handleFocus}
          onClick={this.handleFocus}
        >
          <NewWindow
            ref={this.windowMounted}
            url={`${window.location.origin}/dsmPayment`}
            name="paymentWindow"
            title="Payment Page"
            onUnload={this.handleWindowClose}
            onBlock={this.handleWindowBlock}
            onMounted={this.handleWindowMounted}
            features={windowFeatures}
          >
            <div />
          </NewWindow>
        </Dimmer>
      </React.Fragment>
    );
  }
}

export default PopupPaymentWindow;



// WEBPACK FOOTER //
// ./src/app/components/PaymentRequestFrame/popupWindow.js